import React, { useEffect, useRef, useState } from 'react';
import { AnimatedLoadingPlaceholder } from '../animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { useIntersectionObserver } from '../useIntersectionObserver';
import { CommonWidgetContainer } from './commonWidgetStyle';
import RadarMapWidgetBody from './radarMapWidgetBody';
import { CommonWidgetHeader } from './commonWidgetHeader';
import { translate } from '../../../common/translation/translate';
import { WidgetProps } from '../interfaces/types';
import { getWidgetHeaderText } from '../../../common/utilities/getWidgetHeaderUtil';

export const RadarMapWidgetMobile = ({ widgetLinkURL, enableMapsPageOnWeb2 }: WidgetProps & { enableMapsPageOnWeb2: boolean; }): JSX.Element => {
    const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);
    const widgetRef = useRef(null);

    const isWidgetVisible = useIntersectionObserver(widgetRef, '100px'); // load Radar widget body when it's ~100px from the view port

    useEffect(() => {
        if (!isInitialLoadComplete && isWidgetVisible) {
            setIsInitialLoadComplete(true);   
        }
    }, [isWidgetVisible, isInitialLoadComplete]);

    if (enableMapsPageOnWeb2) {
        return (
            <CommonWidgetContainer ref={widgetRef} href={widgetLinkURL} target='_self' title='Explore Live Weather Radar Map for precipitation Forecasts'> 
                <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('liveRadar') })} />
                {
                    isInitialLoadComplete
                        ? <RadarMapWidgetBody />
                        : <AnimatedLoadingPlaceholder height='100%' radius={0} />
                }
                
            </CommonWidgetContainer>
        );
    }
    return (
        <CommonWidgetContainer ref={widgetRef} href={widgetLinkURL}> 
            <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('liveRadar') })} />
            {
                isInitialLoadComplete
                    ? <RadarMapWidgetBody />
                    : <AnimatedLoadingPlaceholder height='100%' radius={0} />
            }
            
        </CommonWidgetContainer>
    );
};

